module.exports = __webpack_public_path__ + "img/1746605023_J1Ya.1a643bfe.png";